
import { useEditMode } from '../../contexts/EditModeContext'

interface EditModeToggleProps {
  /** Optional additional CSS classes */
  className?: string
}

/**
 * Toggle button for enabling/disabling inline edit mode in market tables.
 * Shows a pencil icon with "Edit Mode" text when inactive (gray),
 * and "Editing" text when active (green).
 */
export default function EditModeToggle({ className = '' }: EditModeToggleProps) {
  const { isEditMode, toggleEditMode } = useEditMode()

  return (
    <button
      onClick={toggleEditMode}
      title={isEditMode ? 'Exit edit mode' : 'Enter edit mode to edit cells inline'}
      className={`
        flex flex-col items-center justify-center px-3 py-1.5 rounded-md text-xs font-medium
        transition-colors duration-150 min-w-[70px]
        ${isEditMode
          ? 'bg-green-600 text-white hover:bg-green-700'
          : 'bg-transparent text-gray-500 hover:bg-gray-200/50'
        }
        ${className}
      `}
    >
      {/* Pencil Icon */}
      <svg
        className={`w-5 h-5 ${isEditMode ? 'text-white' : 'text-gray-500'}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" 
        />
      </svg>
      {/* Label */}
      <span className="mt-0.5">
        {isEditMode ? 'Editing' : 'Edit Mode'}
      </span>
    </button>
  )
}

